import {extend} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import SettingsLinkButton from './components/SettingsLinkButton';

export default function () {
    extend(IndexPage.prototype, 'navItems', function (items) {
        if (app.forum.attribute('formulaireCanManage')) {
            items.add('formulaire', SettingsLinkButton.component());
        }
    });
}
